const TEAM_LABEL_KEYS: Record<string, string> = {
  instinct: 'playerProfile.teams.instinct',
  mystic: 'playerProfile.teams.mystic',
  valor: 'playerProfile.teams.valor',
};

export function teamLabelKey(team: string): string {
  return TEAM_LABEL_KEYS[team] ?? '';
}

export function teamLogoUrl(team: string): string {
  return teamLabelKey(team) ? `/img/${team}-logo.webp` : '';
}
